import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import BlogDataEn from './BlogDataEn'
import BlogDataVi from './BlogDataVi'

export const BlogData = () => {
    const language = useSelector(selectLanguage)

    return language === "en" ? BlogDataEn() : BlogDataVi()
    
}

export const getRandomData = (data) => {
    const selectedData = [];
    while (selectedData.length < 5) {
        const randomIndex = Math.floor(Math.random() * data.length);
        const randomData = data[randomIndex]
        if (!selectedData.includes(randomData)) {
            selectedData.push(randomData);
        }
    }

    return selectedData;
};

// const dataAll = BlogData()

// export const randomlySelectedData = getRandomData(dataAll);

